(ns ui.components.toggle.view
  (:require [common.util :as cu]
            [ui.util :as uu]))

;;TODO: rewrite this with Tailwind

(defn toggle
  "HTML checkbox:
- the component looks like a toggle that user can
  switch between values `label-true` and `label-false`."
  [{:keys [checked? on-change disabled? label-true label label-false input-name dom-id]}]
  (let [component-id (gensym "toggle-component")]
    (fn [{:keys [checked? on-change disabled? label-true label-false input-name dom-id]}]
      (let [icon-class (cond (and checked? disabled?)
                             "fal fa-check text-xs text-disabled-regular-text"
                             checked?
                             "fal fa-check text-xs text-black")]
        ^{:key (str component-id checked? disabled?)}
        [:label
         (merge {:class
                 (uu/cm (cond (and checked? disabled?)
                              "bg-disabled-regular flex-row-reverse"
                              disabled?
                              "bg-disabled-regular "
                              checked?
                              "bg-input-gloomy flex-row-reverse"
                              :else
                              "bg-input-regular ")
                        "flex p-0.5 rounded-full text-secondary-regular-text max-w-10"
                        (if disabled?
                          "cursor-not-allowed"
                          "cursor-pointer"))}
                (when-not (cu/blank-value? dom-id)
                  {:id dom-id}))
         [:span
          {:class (uu/cm (if disabled?
                           "bg-disabled-light-text "
                           "bg-white ")
                         "w-4 h-4 rounded-full flex justify-center items-center")}
          (when checked?
            [:i
             {:class icon-class}])]
         [:input
          {:type      "checkbox"
           :class     "h-0 w-0 opacity-0 absolute"
           :disabled  disabled?
           :checked   checked?
           :on-change (fn [_]
                        (on-change (not checked?)))}]
         [:span
          {:class (uu/cm (if disabled?
                           "text-disabled-regular-text "
                           "text-input-gloomy-text ")
                         "w-5 px-1 block")}
          (if checked?
            label-true
            label-false)]]))))
